import { HttpService } from '@Services/index';
import { useBoundStore } from '@Store/index.ts';
import { OnboardingFormFields } from '@Types/index';
import type { IRegisteredAddressForm } from '@Pages/happyFlowPages/registeredAddress/registeredAddressForm/registeredAddressSchema';

export const setRegisteredAddress = async (props: IRegisteredAddressForm) => {
  const isEmbedded = useBoundStore.getState().onboardingSlice.getIsEmbedded();
  const { customerId } = useBoundStore.getState().customer;
  const url = isEmbedded
    ? `v3/secureonboarding/partner/user/${customerId}/business/address/registered`
    : `v2/secureonboarding/user/${customerId}/business/address/registered`;

  const { data } = await HttpService.post(url, {
    line1: props[OnboardingFormFields.LINE1],
    line2: props[OnboardingFormFields.APARTMENT],
    city: props[OnboardingFormFields.CITY],
    state: props[OnboardingFormFields.STATE]?.value,
    postalCode: props[OnboardingFormFields.ZIP],
    country: 'US',
  });
  return data;
};

export const getRegisteredAddress = async () => {
  const isEmbedded = useBoundStore.getState().onboardingSlice.getIsEmbedded();
  const { customerId } = useBoundStore.getState().customer;
  const url = isEmbedded
    ? `v3/secureonboarding/partner/user/${customerId}/business/address/registered`
    : `v2/secureonboarding/user/${customerId}/business/address/registered`;

  const { data } = await HttpService.get(url);
  return data;
};
